import http, { url } from '../../http'

const API_URL = "business_audit"

class auditoriaAPI {

  async save(gsystem_occupational_hazards) {
    const response = await http(`${API_URL}/save`, 'POST', gsystem_occupational_hazards)
    return response
  }

  async saveA(gsystem_occupational_hazards) {
    const response = await http(`${API_URL}/evidence/save`, 'POST', gsystem_occupational_hazards)
    return response
  }

  async saveMulti(gsystem_occupational_hazards) {
    const response = await http(`${API_URL}/multyStore/save`, 'POST', gsystem_occupational_hazards)
    return response
  }

  async saveEvaluacion(calification_evaluation_providers) {
    const response = await http(`calification_evaluation_providers/save`, 'POST', calification_evaluation_providers)
    return response
  }
 
  async getAll(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  } 

  async getAllA(id, evidence) {
    const response = await http(`${API_URL}/evidence/index/${id}/${evidence}`, 'POST')
    return response
  } 

  async getAllEvidence(id, evidence, page, search) {
    const response = await http(`${API_URL}/evidence/index/${id}/${evidence}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getListR() {
    const response = await http(`${API_URL}/riskList`)
    return response
  } 

  async getListS() {
    const response = await http(`${API_URL}/securityList`)
    return response
  } 

  async getAllS(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getContratistas(id) {
    const response = await http(`gsystem_occupational_hazards/list/${id}`)
    return response
  } 

  
  async getEmpleados(id) {
    const response = await http(`gsystem_occupational_hazards/listEmployees/${id}`)
    return response
  } 

  async getAllSeleccion(idEvaluacion) {
    const response = await http(`calification_evaluation_providers/${idEvaluacion}`)
    return response
  } 

  async getAllEvaluacionSeleccion(idEvaluacion, page, search) {
    const response = await http(`calification_evaluation_providers/${idEvaluacion}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getAllEvaluacion(page, search) {
    const response = await http(`${API_URL}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getShow(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  } 

  async getFiles(id) {
    const response = await http(`identification_evaluation_files/${id}`, 'POST')
    return response
  } 



  async update(id, revision) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', revision)
    return response
  }

  async updateP(id, revision) {
    const response = await http(`${API_URL}/evidence/update/${id}`, 'PUT', revision)
    return response
  }

  async getShowP(id) {
    const response = await http(`${API_URL}/evidence/show/${id}`)
    return response
  } 


  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  async deleteP(id) {
    const response = await http(`${API_URL}/evidence/delete/${id}`, 'DELETE')
    return response
  }

  
}

export default new auditoriaAPI()